<div class="At-Container At-ContainerAudioCall At-ContainerShareScreen">
    <div class="At-VideoStream">
        <figure>
            <img src="assets/images/calling/share-screen.jpg" class="img-fluid" alt="">
        </figure>
    </div>
    <!-- At-VideoStream shareScreenBg ends  -->
    <div class="At-ShareScreenVideo">
        <div class="overlay"></div>
        <figure>
            <img src="assets/images/calling/video-my.png" class="img-fluid" alt="">
        </figure>
        <div class="At-BottomCancel d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center ">
                <i class="icon-video-camera"></i>
                <h6>02:33</h6>
            </div>
            <a href="javascript:void(0);" routerLink="/dashboard" class="At-CancelBtn "><i class="icon-phone-1"></i></a>
        </div>
    </div>
    <!-- At-ShareScreenVideo ends  -->
    <div class="At-ShareScreenControls d-inline-flex">
        <div class="At-CtrlLeft">
            <div class="At-ImgLeft">
                <figure>
                    <img src="assets/images/calling/video-my.png" class="img-fluid" alt="">
                </figure>
            </div>
            <div class="At-ImgText">
                <h6>Anita Enzo</h6>
                <p>Ongoing Call 02:33</p>
            </div>
        </div>
        <div class="At-CtrlRight d-flex justify-content-end">
            <div class="d-flex align-items-center">
                <a href="javascript:void(0);" class="At-IconBtnBlue At-CancelShareBtn" routerLink="/audio-call"><i class="icon-close-sharescreen"></i></a>
                <a href="javascript:void(0);" routerLink="/dashboard" class="At-CancelBtn "><i class="icon-phone-1"></i></a>
            </div>
        </div>
    </div>
    <!-- At-ShareScreenControls ends -->
</div>
